module.exports = __webpack_public_path__ + "static/img/story2.8e610a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/story2.png
// module id = iYam
// module chunks = 1